import Vue from "vue";
import request from "@/utils/request";
import user from "@/utils/user";
import { Toast } from "vant";
// import Cookies from 'js-cookie'

class WXUtils {

  static shareData = {
    "title": "续融宝",
    "desc": "分享描述 ",
    "link": "",
    "imgUrl": `${window.location.origin}/logo/logo.png`
  };

  static getAPPID() {
    return "wx30c19544fb01dee9";
  }

  static toWXLogin(callback) {
    const can = window.location.href.split("?")[1];
    var obj = {};
    if (can) {
      const params = can.split("&");
      params.forEach((n) => {
        if (n) {
          Vue.set(obj, n.split("=")[0], n.split("=")[1]);
        }
      });
    }

    // Cookies.set("token", "Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ0b2tlbiI6IjY5ODA0MDgzNzc2MTc5ODE0NSIsImlzcyI6InhpbmppYW5nZ2FuZ3RvdSIsImF1ZCI6InhpbmppYW5nZ2FuZ3RvdTIifQ.SknqNUEznr77JYFbQ2QeXx0NBvcU3cKntTrGlzcIDCQ");

    let code = obj["code"];
    console.log("code=====>" + code);
    console.log("CacheUserData=====>" + user.getCacheUserData());

    const APPID = this.getAPPID();
    
    if (user.isLogin()) {
      request.get("/User/AccountMng/GetUserInfo")
      .then((res) => {
        // res.data.data.token = user.getCacheToken()
        user.cacheUserData(res.data.data);
        const status = res.data.data.status;
        if (status == 3) {
          callback(1, res.data.data);
        } else if (status == 0 || status == 2) {
          callback(0, "");
        } else {
          callback(-1, res.data.data);
          Toast("正在审核中, 请稍后再试...");
        }
      })
      .catch(() => {});
      return;
    }
    if ((code === null || code === undefined) && !user.isLogin()) {
      const REDIRECT_URI = encodeURIComponent(window.location);
      const authurl = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${APPID}&redirect_uri=${REDIRECT_URI}&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect`;
      window.location.href = authurl;
    } else {

      // const authurl = `https://api.weixin.qq.com/sns/oauth2/access_token?appid=${APPID}&secret=6ca60939ac4fd8d99ada0eac398304c7&code=${code}&grant_type=authorization_code`;
      // window.location.href = authurl;

      // const state = url.get('state');
      // salesmanId 业务员Id

      request.post("/Data/WeChat/GZHGetUserInfo", {
          salesmanId: "",
          code: code,
          encryptedData: "",
          iv: "",
        })
        .then((res) => {
          console.log("res==id===>" + res.data.data.id);
          console.log("res==token===>" + res.data.data.token);
          user.cacheUserData(res.data.data);
          const status = res.data.data.status;
          if (status == 3) {
            callback(1, res.data.data);
          } else if (status == 0 || status == 2) {
            callback(0, "");
          } else {
            callback(-1, res.data.data);
            Toast("正在审核中, 请稍后再试...");
          }
        })
        .catch(() => {});
    }
  }
}

export default WXUtils;
